import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, withKeys as _withKeys, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-close"
}
const _hoisted_2 = ["aria-label", "title"]
const _hoisted_3 = { class: "ai-modal-header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "ai-modal-title" }
const _hoisted_6 = {
  key: 0,
  class: "ai-modal-subtitle"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "ai-modal-title" }
const _hoisted_10 = { class: "ai-modal-subtitle" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "ai-type-row"
}
const _hoisted_14 = { class: "ai-seg" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "ai-start-row"
}
const _hoisted_17 = { class: "ai-seg" }
const _hoisted_18 = {
  key: 1,
  class: "ai-target"
}
const _hoisted_19 = {
  key: 0,
  class: "ai-target-chip"
}
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "ai-target-list" }
const _hoisted_22 = {
  key: 0,
  class: "ai-muted",
  style: {"padding":"8px 10px","font-size":"13px"}
}
const _hoisted_23 = {
  key: 1,
  class: "ai-muted",
  style: {"padding":"8px 10px","font-size":"13px"}
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "ai-target-draft"
}
const _hoisted_26 = {
  key: 2,
  class: "ai-muted"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = {
  key: 3,
  class: "ai-muted"
}
const _hoisted_32 = {
  key: 4,
  class: "ai-muted"
}
const _hoisted_33 = {
  key: 5,
  class: "ai-muted"
}
const _hoisted_34 = {
  key: 6,
  class: "ai-muted"
}
const _hoisted_35 = {
  key: 7,
  class: "ai-muted"
}
const _hoisted_36 = {
  key: 8,
  class: "ai-muted"
}
const _hoisted_37 = {
  key: 9,
  class: "ai-handoff-done"
}
const _hoisted_38 = {
  key: 11,
  class: "ai-muted",
  style: {"font-size":"12.5px","margin":"-4px 0 12px"}
}
const _hoisted_39 = { class: "ai-textarea-wrap" }
const _hoisted_40 = ["placeholder"]
const _hoisted_41 = { class: "ai-video-row" }
const _hoisted_42 = {
  key: 1,
  class: "ai-rec-preview"
}
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "ai-rec-preview-row" }
const _hoisted_45 = { class: "ai-rec-caption" }
const _hoisted_46 = {
  key: 2,
  class: "ai-btn ai-btn-ghost",
  style: {"cursor":"pointer"}
}
const _hoisted_47 = {
  key: 3,
  class: "ai-video-chip"
}
const _hoisted_48 = {
  key: 4,
  class: "ai-btn ai-btn-ghost",
  style: {"cursor":"pointer"}
}
const _hoisted_49 = ["accept"]
const _hoisted_50 = {
  key: 0,
  class: "ai-save-video"
}
const _hoisted_51 = {
  key: 1,
  class: "ai-photo-row"
}
const _hoisted_52 = ["src"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["title"]
const _hoisted_55 = { class: "ai-doc-name" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  class: "ai-muted",
  style: {"font-size":"12px","align-self":"center"}
}
const _hoisted_58 = { style: {"display":"flex","justify-content":"flex-end","margin-top":"12px"} }
const _hoisted_59 = {
  key: 2,
  class: "ai-loading"
}
const _hoisted_60 = { class: "ai-upload-bar" }
const _hoisted_61 = { class: "ai-loading-msg" }
const _hoisted_62 = {
  key: 1,
  class: "ai-loading-msg"
}
const _hoisted_63 = {
  key: 2,
  class: "ai-muted",
  style: {"font-size":"13px","margin-top":"10px"}
}
const _hoisted_64 = {
  key: 3,
  class: "ai-error"
}
const _hoisted_65 = { key: 4 }
const _hoisted_66 = {
  key: 0,
  class: "ai-draft-name",
  style: {"cursor":"default"}
}
const _hoisted_67 = {
  key: 3,
  class: "ai-changes"
}
const _hoisted_68 = { class: "ai-section-label" }
const _hoisted_69 = {
  key: 4,
  class: "ai-placeholder-warn"
}
const _hoisted_70 = { class: "ai-section-label" }
const _hoisted_71 = {
  key: 5,
  class: "ai-preview ai-preview-seats"
}
const _hoisted_72 = { class: "ai-seat-who" }
const _hoisted_73 = {
  key: 0,
  class: "ai-seat-tag"
}
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "ai-seat-h" }
const _hoisted_76 = ["innerHTML"]
const _hoisted_77 = {
  key: 0,
  class: "ai-muted",
  style: {"font-size":"13px"}
}
const _hoisted_78 = {
  key: 6,
  class: "ai-muted",
  style: {"font-size":"13px","margin-top":"8px"}
}
const _hoisted_79 = {
  key: 7,
  class: "ai-preview"
}
const _hoisted_80 = { class: "ai-tl-rail" }
const _hoisted_81 = { class: "ai-tl-body" }
const _hoisted_82 = { class: "ai-tl-line1" }
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = {
  key: 0,
  class: "ai-new-tag"
}
const _hoisted_85 = ["innerHTML"]
const _hoisted_86 = ["innerHTML"]
const _hoisted_87 = ["innerHTML"]
const _hoisted_88 = ["innerHTML"]
const _hoisted_89 = {
  key: 8,
  class: "ai-muted",
  style: {"font-size":"13px","margin-top":"8px"}
}
const _hoisted_90 = {
  key: 9,
  class: "ai-preview"
}
const _hoisted_91 = {
  key: 0,
  class: "ai-preview-textblock"
}
const _hoisted_92 = ["innerHTML"]
const _hoisted_93 = {
  key: 0,
  class: "ai-new-tag"
}
const _hoisted_94 = {
  key: 1,
  class: "ai-preview-task"
}
const _hoisted_95 = { class: "ai-task-text" }
const _hoisted_96 = ["innerHTML"]
const _hoisted_97 = {
  key: 0,
  class: "ai-task-desc"
}
const _hoisted_98 = ["innerHTML"]
const _hoisted_99 = {
  key: 1,
  class: "ai-new-tag"
}
const _hoisted_100 = {
  key: 10,
  class: "ai-preview"
}
const _hoisted_101 = ["onUpdate:modelValue"]
const _hoisted_102 = { style: {"display":"flex","justify-content":"flex-end","margin-top":"8px"} }
const _hoisted_103 = { class: "ai-preview-header" }
const _hoisted_104 = {
  key: 0,
  class: "ai-new-tag"
}
const _hoisted_105 = {
  key: 1,
  class: "ai-step-tools"
}
const _hoisted_106 = ["onClick"]
const _hoisted_107 = ["onClick"]
const _hoisted_108 = ["onClick"]
const _hoisted_109 = ["onClick"]
const _hoisted_110 = ["innerHTML"]
const _hoisted_111 = ["src", "onClick"]
const _hoisted_112 = {
  key: 11,
  style: {"margin-top":"8px"}
}
const _hoisted_113 = {
  key: 12,
  class: "ai-details"
}
const _hoisted_114 = { class: "ai-details-grid" }
const _hoisted_115 = {
  key: 0,
  class: "ai-details-field ai-details-wide"
}
const _hoisted_116 = { class: "ai-details-field" }
const _hoisted_117 = { class: "ai-pills" }
const _hoisted_118 = ["onClick"]
const _hoisted_119 = {
  key: 0,
  class: "ai-field-warn"
}
const _hoisted_120 = { class: "ai-details-field" }
const _hoisted_121 = { class: "ai-pills" }
const _hoisted_122 = ["onClick"]
const _hoisted_123 = {
  key: 0,
  class: "ai-field-warn"
}
const _hoisted_124 = {
  key: 1,
  class: "ai-details-field ai-details-wide"
}
const _hoisted_125 = { class: "ai-pills" }
const _hoisted_126 = ["onClick"]
const _hoisted_127 = { class: "ai-details-field ai-details-wide" }
const _hoisted_128 = {
  key: 0,
  class: "ai-field-warn"
}
const _hoisted_129 = { class: "ai-details-field ai-details-wide" }
const _hoisted_130 = { class: "ai-slug-row" }
const _hoisted_131 = {
  key: 0,
  class: "ai-error",
  style: {"margin":"10px 0 0"}
}
const _hoisted_132 = {
  key: 13,
  style: {"margin":"14px 0"}
}
const _hoisted_133 = {
  key: 14,
  class: "ai-video-note"
}
const _hoisted_134 = ["value", "placeholder"]
const _hoisted_135 = { class: "ai-textarea-wrap" }
const _hoisted_136 = { class: "ai-actions" }
const _hoisted_137 = ["disabled"]
const _hoisted_138 = ["disabled"]
const _hoisted_139 = ["disabled"]
const _hoisted_140 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_ai_meeting_recorder = _resolveComponent("ai-meeting-recorder")!
  const _component_ai_dictation = _resolveComponent("ai-dictation")!
  const _component_ai_screen_recorder = _resolveComponent("ai-screen-recorder")!
  const _component_ai_recording_handoff = _resolveComponent("ai-recording-handoff")!
  const _component_tip_tap = _resolveComponent("tip-tap")!
  const _component_process_owner_picker = _resolveComponent("process-owner-picker")!
  const _component_folder_picker = _resolveComponent("folder-picker")!
  const _component_playbook_view = _resolveComponent("playbook-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.inline ? 'ai-inline-host' : 'error-msg-wrap')
  }, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["form-wrapper ai-modal", _ctx.inline ? 'ai-modal-inline' : 'slide-up'])
    }, [
      (!_ctx.inline || _ctx.phase != 'input')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              "aria-label": _ctx.inline ? 'Start over' : 'Close The Forge',
              title: _ctx.inline ? 'Start over' : 'Close',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requestClose()))
            }, "×", 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _cache[43] || (_cache[43] = _createElementVNode("span", { class: "ai-icon-badge" }, [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 24 24",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z"
            })
          ])
        ], -1)),
        (_ctx.createMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.isExtend ? 'Add to a' : 'Forge a') + " " + _toDisplayString(_ctx.typeNoun), 1),
              (_ctx.phase == 'review')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.isExtend ? 'Check the additions, then save them as a draft.' : 'Check the draft and its details, then create it.'), 1))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "ai-modal-subtitle",
                    title: _ctx.trainingCount ? 'The Forge follows ' + _ctx.trainingCount + ' rules set by company leadership' : ''
                  }, [
                    (_ctx.trainingCount)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("Uses your " + _toDisplayString(_ctx.trainingCount) + " company rule" + _toDisplayString(_ctx.trainingCount == 1 ? '' : 's') + ". ", 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    _cache[40] || (_cache[40] = _createTextVNode("Nothing goes live until you review and save it. ", -1))
                  ], 8, _hoisted_7))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.editOnly ? 'Edit' : _ctx.mode == 'generate' ? 'Generate' : 'Improve') + " " + _toDisplayString(_ctx.typeLabel) + " ", 1),
                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "ai-tag" }, "AI", -1))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.editOnly ? (_ctx.initialDraft && _ctx.initialDraft.changesSummary && _ctx.initialDraft.changesSummary.length ? 'Your ' + _ctx.typeLabel.toLowerCase() + ' with the changes you asked for. Check them, ask for more, then apply.' : 'Your current edits are loaded. Tell the AI what you want changed.') : _ctx.mode == 'generate' ? 'Describe it — the AI writes it' : 'A sharper version of this ' + _ctx.typeLabel.toLowerCase() + ', in seconds') + " ", 1),
                (_ctx.trainingCount)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "ai-trained-pill",
                      title: 'This AI follows ' + _ctx.trainingCount + ' rules set by company leadership'
                    }, [...(_cache[42] || (_cache[42] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "10",
                        height: "10",
                        viewBox: "0 0 24 24",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", { d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" })
                      ], -1),
                      _createTextVNode(" company-trained ", -1)
                    ]))], 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      (_ctx.phase == 'input')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.createMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[44] || (_cache[44] = _createElementVNode("span", { class: "ai-type-label" }, "Make a", -1)),
                  _createElementVNode("span", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (t) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: t.key,
                        class: _normalizeClass(["ai-type-pill", { 'ai-type-on': _ctx.selectedType == t.key }]),
                        onClick: ($event: any) => (_ctx.pickType(t.key))
                      }, [
                        _createVNode(_component_svg_icon, {
                          icon: t.icon
                        }, null, 8, ["icon"]),
                        _createTextVNode(_toDisplayString(t.label), 1)
                      ], 10, _hoisted_15))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.nt == 'meeting')
              ? (_openBlock(), _createBlock(_component_ai_meeting_recorder, {
                  key: 1,
                  ref: "meetingRecorder",
                  onBusy: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isRecording = $event))
                }, null, 512))
              : _createCommentVNode("", true),
            (_ctx.nt != 'meeting')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.createMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[47] || (_cache[47] = _createElementVNode("span", { class: "ai-type-label" }, "Start from", -1)),
                        _createElementVNode("span", _hoisted_17, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["ai-type-pill", { 'ai-type-on': _ctx.startFrom == 'new' }]),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setStartFrom('new')))
                          }, [
                            _cache[45] || (_cache[45] = _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" }),
                              _createElementVNode("path", { d: "M14 3v5h5M12 11v6M9 14h6" })
                            ], -1)),
                            _createTextVNode("New " + _toDisplayString(_ctx.typeNoun), 1)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(["ai-type-pill", { 'ai-type-on': _ctx.startFrom == 'existing' }]),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setStartFrom('existing')))
                          }, [...(_cache[46] || (_cache[46] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" }),
                              _createElementVNode("path", { d: "M14 3v5h5M9 13h6M9 17h4" })
                            ], -1),
                            _createTextVNode("Add to an existing one", -1)
                          ]))], 2)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.createMode && _ctx.startFrom == 'existing')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_ctx.targetSlug)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _cache[48] || (_cache[48] = _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "13",
                                height: "13",
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" })
                              ], -1)),
                              _cache[49] || (_cache[49] = _createTextVNode(" Adding to ", -1)),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.targetName), 1),
                              _createElementVNode("a", {
                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.clearTarget()), ["prevent"])),
                                title: "Choose a different one"
                              }, "change")
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ai-target-search",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.nodeSearch) = $event)),
                                placeholder: 'Search your ' + _ctx.typeLabel.toLowerCase() + 's...',
                                autofocus: ""
                              }, null, 8, _hoisted_20), [
                                [_vModelText, _ctx.nodeSearch]
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                (_ctx.loadingNodes)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Loading..."))
                                  : (!_ctx.filteredNodes.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, "No " + _toDisplayString(_ctx.typeLabel.toLowerCase()) + "s match", 1))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNodes, (n) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: n.slug,
                                    class: "ai-target-option",
                                    onClick: ($event: any) => (_ctx.pickTarget(n))
                                  }, [
                                    _createTextVNode(_toDisplayString(n.name) + " ", 1),
                                    (n.draft)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "draft"))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_24))
                                }), 128))
                              ])
                            ], 64))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isExtend)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                        _cache[50] || (_cache[50] = _createTextVNode("Describe what to add", -1)),
                        (_ctx.nt == 'sheet')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, " — a whole new role, or more duties for a role that's already there"))
                          : (_ctx.nt == 'checklist')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, " — new tasks or a new section"))
                            : (_ctx.nt == 'timeline')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, " — new steps in the flow"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_30, " — new steps or sections")),
                        _cache[51] || (_cache[51] = _createTextVNode(". You can also upload documents or photos (PDF, Word, text) that describe the additions. Everything already there stays exactly as it is; the AI writes the additions in the same style.", -1))
                      ]))
                    : (_ctx.nt == 'process' && _ctx.videoImprove)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_31, [...(_cache[52] || (_cache[52] = [
                          _createElementVNode("strong", null, "Show the AI how this process is done now", -1),
                          _createTextVNode(" — record your screen, upload a recording, add photos of the work, or upload the current written procedure (PDF, Word, text). The AI compares it against the current version of this process and drafts the update.", -1)
                        ]))]))
                      : (!_ctx.createMode && _ctx.nt == 'process' && _ctx.canRecord)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, [...(_cache[53] || (_cache[53] = [
                            _createTextVNode("Describe the process in your own words, ", -1),
                            _createElementVNode("strong", null, "record your screen right here", -1),
                            _createTextVNode(" while you do it, upload a screen recording, add photos of hands-on work, or upload existing documents (PDF, Word, text) — the AI writes the process, and attaches an image to each step it saw. You can also add a note alongside a capture.", -1)
                          ]))]))
                        : (!_ctx.createMode && _ctx.nt == 'process')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_33, [...(_cache[54] || (_cache[54] = [
                              _createTextVNode("Describe the process in your own words, ", -1),
                              _createElementVNode("strong", null, "upload a screen recording, photos or documents", -1),
                              _createTextVNode(" (PDF, Word, text) — the AI writes the process and attaches an image to each step it saw. (To record your screen directly in the app, open this page on a desktop computer.)", -1)
                            ]))]))
                          : (!_ctx.createMode && _ctx.nt == 'checklist')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_34, "Describe the checklist in your own words — what job it's for and what needs to be checked — or upload a document or photos to build it from. The AI matches the format of your existing checklists."))
                            : (!_ctx.createMode && _ctx.nt == 'sheet')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_35, "Describe the sheet you need — for example a role and its duties — or upload a job description, org chart or notes to build it from. The AI matches the sections and style of your existing role sheets."))
                              : (!_ctx.createMode && _ctx.nt == 'timeline')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_36, "Describe the workflow — the steps, who handles each one, and rough timing if you know it — or upload a document or diagram of it. The AI matches the format of your existing value engines."))
                                : _createCommentVNode("", true),
                  (_ctx.handoffSent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("strong", null, "Sent to " + _toDisplayString(_ctx.handoffSent.to) + ".", 1),
                        _cache[55] || (_cache[55] = _createTextVNode(" They get an email with the recording, and it waits under My AI Captures for you both until they build or discard it. ", -1)),
                        _createElementVNode("a", {
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.handoffSent = null), ["prevent"]))
                        }, "OK")
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.createMode)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 10,
                        class: _normalizeClass(["ai-methods", { 'ai-methods-locked': _ctx.isRecording }])
                      }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["ai-method", { 'ai-method-on': _ctx.inputMethod == 'describe' }]),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setMethod('describe')))
                        }, [...(_cache[56] || (_cache[56] = [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" }),
                            _createElementVNode("path", { d: "M8 9h8M8 13h5" })
                          ], -1),
                          _createElementVNode("strong", null, "Describe it", -1),
                          _createElementVNode("span", null, "Type it, or tap the mic and talk.", -1)
                        ]))], 2),
                        (_ctx.recordable && _ctx.canRecord)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: _normalizeClass(["ai-method", { 'ai-method-on': _ctx.inputMethod == 'record' }]),
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setMethod('record')))
                            }, [...(_cache[57] || (_cache[57] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("rect", {
                                  x: "2",
                                  y: "3",
                                  width: "20",
                                  height: "14",
                                  rx: "2"
                                }),
                                _createElementVNode("path", { d: "M8 21h8M12 17v4" })
                              ], -1),
                              _createElementVNode("strong", null, "Record your screen", -1),
                              _createElementVNode("span", null, "Do the work while the Forge watches and listens.", -1)
                            ]))], 2))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["ai-method", { 'ai-method-on': _ctx.inputMethod == 'upload' }]),
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setMethod('upload')))
                        }, [
                          _cache[58] || (_cache[58] = _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                          ], -1)),
                          _cache[59] || (_cache[59] = _createElementVNode("strong", null, "Upload", -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.recordable ? 'Recordings, photos, PDFs, Word or text files.' : 'Photos, PDFs, Word or text files.'), 1)
                        ], 2)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.createMode && _ctx.recordable && !_ctx.canRecord)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_38, "To record your screen right here, open this page on a desktop computer."))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["ai-input-stack", { 'ai-capture-first': _ctx.createMode && _ctx.inputMethod != 'describe' }])
                  }, [
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.description) = $event)),
                        rows: "5",
                        placeholder: _ctx.inputPlaceholder,
                        style: {"width":"100%","box-sizing":"border-box"}
                      }, null, 8, _hoisted_40), [
                        [_vModelText, _ctx.description]
                      ]),
                      _createVNode(_component_ai_dictation, {
                        class: "ai-dict-pos",
                        onText: _cache[11] || (_cache[11] = ($event: any) => (_ctx.description = (_ctx.description ? _ctx.description.trim() + ' ' : '') + $event))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      (_ctx.recordable && !_ctx.videoFile && !_ctx.screenRec)
                        ? _withDirectives((_openBlock(), _createBlock(_component_ai_screen_recorder, {
                            key: 0,
                            onRecorded: _ctx.onScreenRecorded,
                            onRecording: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isRecording = $event)),
                            onDiscard: _cache[13] || (_cache[13] = ($event: any) => (_ctx.discardScreenRec()))
                          }, null, 8, ["onRecorded"])), [
                            [_vShow, !_ctx.createMode || _ctx.inputMethod == 'record']
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.recordable && _ctx.screenRec)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("video", {
                              src: _ctx.screenRecUrl,
                              controls: "",
                              playsinline: ""
                            }, null, 8, _hoisted_43),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("span", _hoisted_45, "Screen recording — " + _toDisplayString(_ctx.screenRecLabel), 1),
                              _createElementVNode("a", {
                                onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.discardScreenRec()), ["prevent"]))
                              }, "Remove")
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.recordable && !_ctx.screenRec && !_ctx.isRecording && (!_ctx.createMode || _ctx.inputMethod == 'upload'))
                        ? (_openBlock(), _createElementBlock("label", _hoisted_46, [
                            _cache[60] || (_cache[60] = _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "currentColor"
                            }, [
                              _createElementVNode("path", { d: "M15 8v8H5V8h10zm2 2.5V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4.5l5 4v-11l-5 4z" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.videoFile ? 'Change recording' : 'Upload screen recording') + " ", 1),
                            _createElementVNode("input", {
                              type: "file",
                              accept: "video/mp4,video/quicktime,video/webm",
                              style: {"display":"none"},
                              onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onVideoPicked && _ctx.onVideoPicked(...args)))
                            }, null, 32)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.recordable && _ctx.videoFile)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                            _createTextVNode(_toDisplayString(_ctx.videoFile.name) + " (" + _toDisplayString((_ctx.videoFile.size / 1024 / 1024).toFixed(1)) + " MB) ", 1),
                            _createElementVNode("a", {
                              onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.videoFile = null), ["prevent"])),
                              style: {"cursor":"pointer","margin-left":"6px"}
                            }, "×")
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.videoFile && !_ctx.screenRec && !_ctx.isRecording && (!_ctx.createMode || _ctx.inputMethod == 'upload'))
                        ? (_openBlock(), _createElementBlock("label", _hoisted_48, [
                            _cache[61] || (_cache[61] = _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "currentColor"
                            }, [
                              _createElementVNode("path", { d: "M12 10.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0-2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zM20 5h-3.17l-1.24-1.35A2 2 0 0 0 14.12 3H9.88a2 2 0 0 0-1.47.65L7.17 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString((_ctx.photos.length || _ctx.docs.length) ? 'Add more files' : 'Add photos or documents') + " ", 1),
                            _createElementVNode("input", {
                              type: "file",
                              accept: _ctx.fileAccept,
                              multiple: "",
                              style: {"display":"none"},
                              onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onFilesPicked && _ctx.onFilesPicked(...args)))
                            }, null, 40, _hoisted_49)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.recordable && (_ctx.screenRec || _ctx.videoFile) && !_ctx.isRecording)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_50, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.saveVideo) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.saveVideo]
                          ]),
                          _cache[63] || (_cache[63] = _createElementVNode("span", {
                            class: "ai-save-video-switch",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createElementVNode("span", null, [
                            _cache[62] || (_cache[62] = _createElementVNode("strong", null, "Save the video with it", -1)),
                            _createElementVNode("em", null, _toDisplayString(_ctx.saveVideo ? 'The recording is added to Videos next to the new ' + _ctx.typeNoun + '.' : 'The recording is only used to write the draft, then deleted.'), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.photos.length || _ctx.docs.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'p' + i,
                              class: "ai-photo-thumb"
                            }, [
                              _createElementVNode("img", {
                                src: photo.url
                              }, null, 8, _hoisted_52),
                              _createElementVNode("span", {
                                class: "ai-photo-x",
                                onClick: ($event: any) => (_ctx.removePhoto(i))
                              }, "×", 8, _hoisted_53)
                            ]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (doc, i) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'd' + i,
                              class: "ai-doc-chip",
                              title: doc.file.name
                            }, [
                              _cache[64] || (_cache[64] = _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "13",
                                height: "13",
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zM8 13h8v2H8v-2zm0 4h8v2H8v-2z" })
                              ], -1)),
                              _createElementVNode("span", _hoisted_55, _toDisplayString(doc.file.name), 1),
                              _createElementVNode("em", null, _toDisplayString(doc.file.size >= 1024 * 1024 ? (doc.file.size / 1024 / 1024).toFixed(1) + ' MB' : Math.max(1, Math.round(doc.file.size / 1024)) + ' KB'), 1),
                              _createElementVNode("a", {
                                onClick: _withModifiers(($event: any) => (_ctx.removeDoc(i)), ["prevent"])
                              }, "×", 8, _hoisted_56)
                            ], 8, _hoisted_54))
                          }), 128)),
                          _createElementVNode("span", _hoisted_57, [
                            (_ctx.photos.length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.photos.length) + "/15 photos — order matters, arrange the story of the task", 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.photos.length && _ctx.docs.length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(" · ")
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.docs.length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(_ctx.docs.length) + " document" + _toDisplayString(_ctx.docs.length == 1 ? '' : 's') + " — the AI reads " + _toDisplayString(_ctx.docs.length == 1 ? 'it' : 'them') + " in full", 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.canHandoff)
                    ? (_openBlock(), _createBlock(_component_ai_recording_handoff, {
                        key: 12,
                        recording: _ctx.screenRec,
                        file: _ctx.videoFile,
                        note: _ctx.description,
                        "node-type": _ctx.nt,
                        onSent: _ctx.onHandoffSent
                      }, null, 8, ["recording", "file", "note", "node-type", "onSent"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["ai-btn", (_ctx.isRecording || (_ctx.createMode && _ctx.startFrom == 'existing' && !_ctx.targetSlug) || (_ctx.videoImprove ? !_ctx.hasCapture : (!_ctx.description.trim() && !_ctx.hasCapture))) ? 'disable-button' : '']),
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.generate()))
                    }, [
                      _cache[65] || (_cache[65] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z"
                        })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.isExtend ? 'Write the Additions' : 'Generate ' + _ctx.typeLabel), 1)
                    ], 2)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.phase == 'loading')
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _cache[67] || (_cache[67] = _createElementVNode("div", { class: "ai-loading-orb" }, null, -1)),
            (_ctx.uploadPct !== null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ width: _ctx.uploadPct + '%' })
                    }, null, 4)
                  ]),
                  _createElementVNode("div", _hoisted_61, "Uploading recording... " + _toDisplayString(_ctx.uploadPct) + "%", 1)
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString((_ctx.activeJobId && _ctx.jobStage) || _ctx.loadingMessage), 1)),
            _cache[68] || (_cache[68] = _createElementVNode("div", {
              class: "ai-muted",
              style: {"font-size":"13px"}
            }, "This usually takes 20–40 seconds", -1)),
            (_ctx.activeJobId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.inline ? 'You can leave this page.' : 'You can close this window.'), 1),
                  _cache[66] || (_cache[66] = _createTextVNode(" If you're away when it finishes, we'll email you a link. If you review the result here, no email is needed.", -1))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
            _createElementVNode("a", {
              onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.retry()), ["prevent"])),
              style: {"margin-left":"8px"}
            }, "Try again")
          ]))
        : _createCommentVNode("", true),
      (_ctx.phase == 'review' && _ctx.draft)
        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
            (_ctx.isExtend)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                  _cache[69] || (_cache[69] = _createElementVNode("span", { class: "ai-extend-lead" }, "Adding to", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.draft.name), 1)
                ]))
              : (_ctx.editingName)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 1,
                    class: "ai-edit-name",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.draft.name) = $event)),
                    onKeyup: _cache[22] || (_cache[22] = _withKeys(($event: any) => (_ctx.editingName = false), ["enter"])),
                    onBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.editingName = false))
                  }, null, 544)), [
                    [_vModelText, _ctx.draft.name]
                  ])
                : (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "ai-draft-name",
                    title: "Click to edit the name",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.editingName = true))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.draft.name), 1),
                    _cache[70] || (_cache[70] = _createElementVNode("span", { class: "ai-edit-btn" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "13",
                        height: "13",
                        viewBox: "0 0 24 24",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", { d: "M14.078 4.232l5.688 5.688-9.398 9.398-5.687-5.688 9.397-9.398zm5.586-1.727l1.831 1.831c.78.781.78 2.047 0 2.828l-1.485 1.485-5.687-5.688 1.484-1.484c.781-.781 2.048-.781 2.828 0l1.029 1.028zm-17.664 17.667l1.831-6.518 5.688 5.687-6.518 1.832c-.554.155-1.156-.447-1.001-1.001z" })
                      ])
                    ], -1))
                  ])),
            (_ctx.draft.changesSummary && _ctx.draft.changesSummary.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.revisionCount > 0 ? 'What changed in this revision' : 'What the AI did'), 1),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.changesSummary, (change, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(change), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.placeholderCount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _createTextVNode(_toDisplayString(_ctx.placeholderCount) + " detail" + _toDisplayString(_ctx.placeholderCount == 1 ? '' : 's') + " marked ", 1),
                  _cache[71] || (_cache[71] = _createElementVNode("strong", null, "[confirm: ...]", -1)),
                  _cache[72] || (_cache[72] = _createTextVNode(" for you to verify — fill these in before publishing. ", -1))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.typeLabel) + " preview", 1),
            (_ctx.nt == 'sheet' && _ctx.draft.sheet)
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewSeats, (seat) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: seat.id,
                      class: _normalizeClass(['ai-seat', { 'ai-new': _ctx.isNewSeat(seat) }])
                    }, [
                      _createElementVNode("div", _hoisted_72, [
                        _createTextVNode(_toDisplayString(_ctx.seatLabel(seat) || 'New seat'), 1),
                        (_ctx.isNewSeat(seat))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_73, "New"))
                          : _createCommentVNode("", true)
                      ]),
                      (seat.accountabilities.length)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(['ai-seat-sec', { 'ai-new-cell': _ctx.isChangedSection(seat, 'acc') }])
                          }, [
                            _cache[73] || (_cache[73] = _createElementVNode("div", { class: "ai-seat-h" }, "Accountabilities", -1)),
                            _createElementVNode("ol", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seat.accountabilities, (a, k) => {
                                return (_openBlock(), _createElementBlock("li", { key: k }, [
                                  _createElementVNode("b", null, _toDisplayString(a.value), 1),
                                  (a.value2)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, " — " + _toDisplayString(a.value2), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ], 2))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.sheet.sections, (section) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: section.id
                        }, [
                          (seat.values[section.id])
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(['ai-seat-sec', { 'ai-new-cell': _ctx.isChangedSection(seat, section.id) }])
                              }, [
                                _createElementVNode("div", _hoisted_75, _toDisplayString(section.label), 1),
                                _createElementVNode("div", {
                                  innerHTML: _ctx.renderBody(seat.values[section.id])
                                }, null, 8, _hoisted_76)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ], 2))
                  }), 128)),
                  (_ctx.isExtend && _ctx.draft.sheet.seats.length > _ctx.previewSeats.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.draft.sheet.seats.length - _ctx.previewSeats.length) + " other seat" + _toDisplayString(_ctx.draft.sheet.seats.length - _ctx.previewSeats.length == 1 ? '' : 's') + " unchanged.", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.nt == 'sheet')
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, "People are linked to a seat from their employee page (Assign Role) after saving."))
              : _createCommentVNode("", true),
            (_ctx.nt == 'timeline')
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.items, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass(["ai-preview-tl", { 'ai-new': _ctx.isNewItem(i) }])
                    }, [
                      _createElementVNode("span", _hoisted_80, [
                        _createElementVNode("span", {
                          class: "ai-tl-dot",
                          style: _normalizeStyle({ background: item.color })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.renderText(item.lineOne)
                          }, null, 8, _hoisted_83),
                          (_ctx.isNewItem(i))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_84, "New"))
                            : _createCommentVNode("", true)
                        ]),
                        (item.lineTwo)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "ai-tl-line2",
                              innerHTML: _ctx.renderText(item.lineTwo)
                            }, null, 8, _hoisted_85))
                          : _createCommentVNode("", true),
                        (item.lineThree)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "ai-tl-line2",
                              innerHTML: _ctx.renderText(item.lineThree)
                            }, null, 8, _hoisted_86))
                          : _createCommentVNode("", true),
                        (_ctx.smallLines(item))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "ai-tl-small",
                              innerHTML: _ctx.renderText(_ctx.smallLines(item))
                            }, null, 8, _hoisted_87))
                          : _createCommentVNode("", true),
                        (item.description)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              class: "ai-tl-desc",
                              innerHTML: _ctx.renderBody(item.description)
                            }, null, 8, _hoisted_88))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.nt == 'timeline')
              ? (_openBlock(), _createElementBlock("div", _hoisted_89, "Step links and images are added by you after saving — colors follow your existing value engines."))
              : _createCommentVNode("", true),
            (_ctx.nt == 'checklist')
              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.items, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass({ 'ai-new': _ctx.isNewChecklistItem(item) })
                    }, [
                      (item.type == 'textblock')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _createElementVNode("span", {
                              innerHTML: _ctx.renderBody(item.text)
                            }, null, 8, _hoisted_92),
                            (_ctx.isNewChecklistItem(item))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_93, "New"))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_94, [
                            _cache[75] || (_cache[75] = _createElementVNode("span", { class: "ai-task-box" }, null, -1)),
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("strong", {
                                innerHTML: _ctx.renderText(item.label)
                              }, null, 8, _hoisted_96),
                              (item.description)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_97, [
                                    _cache[74] || (_cache[74] = _createTextVNode(": ", -1)),
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.renderText(item.description)
                                    }, null, 8, _hoisted_98)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.isNewChecklistItem(item))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_99, "New"))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.nt == 'process')
              ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.items, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass(["ai-preview-item", { 'ai-new': _ctx.isNewItem(i) }])
                    }, [
                      (_ctx.editingIdx === i)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "ai-edit-header",
                              "onUpdate:modelValue": ($event: any) => ((item.header) = $event)
                            }, null, 8, _hoisted_101), [
                              [_vModelText, item.header]
                            ]),
                            _createVNode(_component_tip_tap, {
                              modelValue: item.body,
                              "onUpdate:modelValue": ($event: any) => ((item.body) = $event),
                              "show-align": true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("div", {
                                class: "ai-btn ai-btn-ghost ai-edit-done",
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.editingIdx = null))
                              }, "Done")
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_103, [
                              _createTextVNode(_toDisplayString(item.header), 1),
                              (_ctx.isNewItem(i))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_104, "New"))
                                : _createCommentVNode("", true),
                              (!_ctx.isExtend || _ctx.isNewItem(i))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_105, [
                                    _createElementVNode("span", {
                                      class: "ai-edit-btn",
                                      title: "Edit this step",
                                      onClick: ($event: any) => (_ctx.editingIdx = i)
                                    }, [...(_cache[76] || (_cache[76] = [
                                      _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "13",
                                        height: "13",
                                        viewBox: "0 0 24 24",
                                        fill: "currentColor"
                                      }, [
                                        _createElementVNode("path", { d: "M14.078 4.232l5.688 5.688-9.398 9.398-5.687-5.688 9.397-9.398zm5.586-1.727l1.831 1.831c.78.781.78 2.047 0 2.828l-1.485 1.485-5.687-5.688 1.484-1.484c.781-.781 2.048-.781 2.828 0l1.029 1.028zm-17.664 17.667l1.831-6.518 5.688 5.687-6.518 1.832c-.554.155-1.156-.447-1.001-1.001z" })
                                      ], -1)
                                    ]))], 8, _hoisted_106),
                                    (!_ctx.isExtend)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass(["ai-edit-btn", { 'ai-tool-off': i === 0 }]),
                                          title: "Move up",
                                          onClick: ($event: any) => (_ctx.moveStep(i, -1))
                                        }, [...(_cache[77] || (_cache[77] = [
                                          _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "13",
                                            height: "13",
                                            viewBox: "0 0 24 24",
                                            fill: "currentColor"
                                          }, [
                                            _createElementVNode("path", { d: "M12 3l12 18h-24z" })
                                          ], -1)
                                        ]))], 10, _hoisted_107))
                                      : _createCommentVNode("", true),
                                    (!_ctx.isExtend)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: _normalizeClass(["ai-edit-btn", { 'ai-tool-off': i === _ctx.draft.items.length - 1 }]),
                                          title: "Move down",
                                          onClick: ($event: any) => (_ctx.moveStep(i, 1))
                                        }, [...(_cache[78] || (_cache[78] = [
                                          _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "13",
                                            height: "13",
                                            viewBox: "0 0 24 24",
                                            fill: "currentColor"
                                          }, [
                                            _createElementVNode("path", { d: "M12 21l-12-18h24z" })
                                          ], -1)
                                        ]))], 10, _hoisted_108))
                                      : _createCommentVNode("", true),
                                    (!_ctx.isExtend)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 2,
                                          class: "ai-edit-btn ai-tool-danger",
                                          title: "Delete this step",
                                          onClick: ($event: any) => (_ctx.deleteStep(i))
                                        }, [...(_cache[79] || (_cache[79] = [
                                          _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "13",
                                            height: "13",
                                            viewBox: "0 0 24 24",
                                            fill: "currentColor"
                                          }, [
                                            _createElementVNode("path", { d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" })
                                          ], -1)
                                        ]))], 8, _hoisted_109))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                              class: "ai-preview-body",
                              innerHTML: _ctx.renderBody(item.body)
                            }, null, 8, _hoisted_110)
                          ], 64)),
                      (item.image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            src: _ctx.draftMediaUrl(item.image),
                            class: "ai-preview-shot",
                            loading: "lazy",
                            title: "Click to enlarge",
                            onClick: ($event: any) => (_ctx.lightboxUrl = _ctx.draftMediaUrl(item.image))
                          }, null, 8, _hoisted_111))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.nt == 'process' && !_ctx.isExtend)
              ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                  _createElementVNode("a", {
                    class: "ai-add-step",
                    onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.addStep()), ["prevent"]))
                  }, "+ Add a step")
                ]))
              : _createCommentVNode("", true),
            (_ctx.createMode && _ctx.meta && !_ctx.isExtend)
              ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                  _cache[86] || (_cache[86] = _createElementVNode("div", {
                    class: "ai-section-label",
                    style: {"margin-top":"0"}
                  }, [
                    _createTextVNode("Details "),
                    _createElementVNode("span", { class: "ai-details-hint" }, "filled in by the AI — change anything you like")
                  ], -1)),
                  _createElementVNode("div", _hoisted_114, [
                    (_ctx.nt != 'checklist')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.typeLabel) + " owner", 1),
                          _createVNode(_component_process_owner_picker, {
                            modelValue: _ctx.meta.processOwnerIDs,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.meta.processOwnerIDs) = $event))
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_116, [
                      _cache[80] || (_cache[80] = _createElementVNode("label", null, "Locations", -1)),
                      _createElementVNode("div", _hoisted_117, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyLocations, (loc, i) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: i,
                            class: _normalizeClass(["ai-pill", { 'ai-pill-on': _ctx.meta.locations.includes(loc) }]),
                            onClick: ($event: any) => (_ctx.togglePick(_ctx.meta.locations, loc))
                          }, _toDisplayString(loc), 11, _hoisted_118))
                        }), 128))
                      ]),
                      (!_ctx.meta.locations.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_119, "Pick at least one location"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_120, [
                      _cache[81] || (_cache[81] = _createElementVNode("label", null, "Departments", -1)),
                      _createElementVNode("div", _hoisted_121, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyDepartments, (dep, i) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: i,
                            class: _normalizeClass(["ai-pill", { 'ai-pill-on': _ctx.meta.departments.includes(dep) }]),
                            onClick: ($event: any) => (_ctx.togglePick(_ctx.meta.departments, dep))
                          }, _toDisplayString(dep), 11, _hoisted_122))
                        }), 128))
                      ]),
                      (!_ctx.meta.departments.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_123, "Pick at least one department"))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.companyTypes.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                          _cache[82] || (_cache[82] = _createElementVNode("label", null, "Types", -1)),
                          _createElementVNode("div", _hoisted_125, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyTypes, (t, i) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: i,
                                class: _normalizeClass(["ai-pill ai-pill-alt", { 'ai-pill-on': _ctx.meta.types.includes(t) }]),
                                onClick: ($event: any) => (_ctx.togglePick(_ctx.meta.types, t))
                              }, _toDisplayString(t), 11, _hoisted_126))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_127, [
                      _cache[83] || (_cache[83] = _createElementVNode("label", null, "Folders", -1)),
                      _createVNode(_component_folder_picker, {
                        modelValue: _ctx.meta.folderSlugs,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.meta.folderSlugs) = $event))
                      }, null, 8, ["modelValue"]),
                      (!_ctx.meta.folderSlugs.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_128, "Pick at least one folder so people can find it"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      _cache[85] || (_cache[85] = _createElementVNode("label", null, "Link", -1)),
                      _createElementVNode("div", _hoisted_130, [
                        _cache[84] || (_cache[84] = _createElementVNode("span", null, "/playbook/", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.meta.slug) = $event)),
                          onInput: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.onSlugEdit && _ctx.onSlugEdit(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.meta.slug]
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.detailsError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, _toDisplayString(_ctx.detailsError), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.draft.suggestedDepartments?.length || _ctx.draft.suggestedTypes?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.suggestedDepartments, (d, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: 'd'+i,
                        class: "ai-chip"
                      }, _toDisplayString(d), 1))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.suggestedTypes, (t, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: 't'+i,
                        class: "ai-chip ai-chip-type"
                      }, _toDisplayString(t), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
            (_ctx.recordingBecomesVideo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                  _cache[89] || (_cache[89] = _createElementVNode("label", { for: "ai-video-title" }, [
                    _createTextVNode("▶ "),
                    _createElementVNode("strong", null, "Video title")
                  ], -1)),
                  _createElementVNode("input", {
                    id: "ai-video-title",
                    type: "text",
                    maxlength: "200",
                    value: _ctx.videoTitleValue,
                    onInput: _cache[31] || (_cache[31] = ($event: any) => {_ctx.videoTitle = $event.target.value; _ctx.videoTitleEdited = true}),
                    placeholder: _ctx.videoDefaultTitle || 'Name the video'
                  }, null, 40, _hoisted_134),
                  _createElementVNode("span", null, [
                    _cache[87] || (_cache[87] = _createTextVNode("The screen recording is saved under ", -1)),
                    _cache[88] || (_cache[88] = _createElementVNode("strong", null, "Processes → Videos", -1)),
                    _createTextVNode(" as “" + _toDisplayString(_ctx.videoNodeName) + "”.", 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[92] || (_cache[92] = _createElementVNode("div", { class: "ai-section-label" }, "Want anything changed?", -1)),
            _createElementVNode("div", _hoisted_135, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.feedback) = $event)),
                rows: "3",
                placeholder: "e.g. Add a step for documenting the claim in the CRM, and make the safety warnings stronger...",
                style: {"width":"100%","box-sizing":"border-box"}
              }, null, 512), [
                [_vModelText, _ctx.feedback]
              ]),
              _createVNode(_component_ai_dictation, {
                class: "ai-dict-pos",
                onText: _cache[33] || (_cache[33] = ($event: any) => (_ctx.feedback = (_ctx.feedback ? _ctx.feedback.trim() + ' ' : '') + $event))
              })
            ]),
            _createElementVNode("div", _hoisted_136, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["ai-btn", !_ctx.feedback.trim() || _ctx.busy ? 'disable-button' : '']),
                disabled: !_ctx.feedback.trim() || _ctx.busy,
                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.requestChanges()))
              }, [...(_cache[90] || (_cache[90] = [
                _createElementVNode("svg", {
                  "aria-hidden": "true",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "15",
                  height: "15",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "m16 3 5 5M3 21l5-1L21 7a2 2 0 0 0-4-4L4 16z" })
                ], -1),
                _createTextVNode(" Request Changes ", -1)
              ]))], 10, _hoisted_137),
              (_ctx.nt == 'process')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    ref: "previewButton",
                    type: "button",
                    class: "ai-btn ai-btn-ghost",
                    disabled: _ctx.previewLoading || _ctx.busy,
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.openDraftPreview()))
                  }, _toDisplayString(_ctx.previewLoading ? 'Opening Preview…' : 'Preview'), 9, _hoisted_138))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["ai-btn ai-btn-ghost ai-accept", _ctx.busy ? 'disable-button' : '']),
                disabled: _ctx.busy,
                onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.accept()))
              }, [
                _cache[91] || (_cache[91] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.busy ? (_ctx.isExtend ? 'Saving...' : 'Creating...') : (_ctx.isExtend ? 'Save Additions as Draft' : _ctx.acceptLabel || (_ctx.createMode ? 'Create ' + _ctx.typeLabel : _ctx.mode == 'generate' ? 'Use This ' + _ctx.typeLabel : 'Apply to Editor'))), 1)
              ], 10, _hoisted_139)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2), [
      [_vShow, !_ctx.previewNode]
    ]),
    (_ctx.lightboxUrl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "ai-lightbox",
          onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.lightboxUrl = ''))
        }, [
          _createElementVNode("img", { src: _ctx.lightboxUrl }, null, 8, _hoisted_140)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.previewNode)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "previewDialog",
            tabindex: "-1",
            class: "playbook-preview-overlay ai-draft-preview",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "Process preview",
            onKeydown: _cache[39] || (_cache[39] = _withKeys(_withModifiers(($event: any) => (_ctx.closeDraftPreview()), ["stop"]), ["esc"]))
          }, [
            _createVNode(_component_playbook_view, {
              "preview-node": _ctx.previewNode,
              onClosePreview: _cache[38] || (_cache[38] = ($event: any) => (_ctx.closeDraftPreview()))
            }, null, 8, ["preview-node"])
          ], 544))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}